export default __webpack_public_path__ + "static/media/profileUser.84418e17.png";